import React from 'react'
import Tutorprofilee from '../../Components/client/Tutorprofile'
function Tutorprofile() {
  return (
    <div>
      <Tutorprofilee/>
    </div>
  )
}

export default Tutorprofile
